module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Excursuses")]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("1. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE OF THE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("2. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOODLINES IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#exc3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("3. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLE OF THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("4. W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AS THE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILIC")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY A")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECT")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("5. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESSIANISM IN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v("-N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("6. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITUAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URIFICATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("7. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDRASH")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORAH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#exc8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("8. Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADOKITE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIESTS IN THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "pad1"
  }, [_vm._v("9. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACRILEGE OF")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERMARRIAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#exc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONVERSION IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTING IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMARIANS AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMARITANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSECRATION OF THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBILEE AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBATICAL")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROPHECY IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#exc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOULD")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v(" 8 F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLOW")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v(" 8?")])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EGACIES OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA AND")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENITENTIAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAYER IN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVENANT AND")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#exc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERUSALEM, THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC AND")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "excur"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#exc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTILE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPURITY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bce5d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Excursuses.vue
// module id = 72
// module chunks = 0